// extracted by mini-css-extract-plugin
module.exports = {"item":"UseCaseAnimation_item__20zY0","cart":"UseCaseAnimation_cart__3-Rk9","margin":"UseCaseAnimation_margin__3Xc37","jello-horizontal":"UseCaseAnimation_jello-horizontal__3WpET"};